import { EUserRoles } from '../enums/EUserRoles';

/**
 * Users with any of these roles may access the multifund factsheet. Mirrors the backend gate.
 */
export const CMultifundFactsheetRoles: EUserRoles[][] = [
  [EUserRoles.PROFESSIONAL_CLIENT],
  [EUserRoles.SUITABLE_COUNTERPARTY],
  [EUserRoles.STAFF]
];
